(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["studio-bite-customer-proof"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sb-customer-proof__video').forEach(detail => {
  detail.addEventListener('toggle', () => {
    const holder=detail.querySelector('[data-video-id]');
    if(detail.open && !holder.firstChild){const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(holder.dataset.videoId);frame.title=holder.dataset.videoTitle;frame.allow='encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;holder.append(frame);}
    if(!detail.open) holder.replaceChildren();
  });
});

  } catch(e) { console.error(e); }
})();
})();
